// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3EdNG","colMaxWidth":"Table_colMaxWidth__3U5bP"};